import { render, staticRenderFns } from "./MusteriDetay.vue?vue&type=template&id=76bc6519&scoped=true&"
import script from "./MusteriDetay.vue?vue&type=script&lang=js&"
export * from "./MusteriDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc6519",
  null
  
)

export default component.exports